import React from "react";
import { Modal, Image } from "react-bootstrap";
import { isEmpty } from "lodash";

const DeleteModal = ({
  // support multiple names for compatibility
  onDelete,
  onConfirm,
  show,
  onClose,
  onHide,
  message,
  deleteBtnTxt = "Delete",
}) => {
  const handleDelete = () => {
    if (typeof onDelete === "function") {
      return onDelete();
    }
    if (typeof onConfirm === "function") {
      return onConfirm();
    }
    // no-op, avoid crash
    console.warn("DeleteModal: no delete handler provided");
  };

  const handleClose = () => {
    if (typeof onClose === "function") return onClose();
    if (typeof onHide === "function") return onHide();
    // fallback: do nothing
    console.warn("DeleteModal: no close handler provided");
  };

  return (
    <Modal show={!!show} centered onHide={handleClose}>
      <Modal.Body className="text-center">
        <div className="mb-3">
          <Image src="/assets/images/Delete-main.svg" alt="Delete Icon" />
        </div>
        <p className="font-14 font-weight-medium mb-4">
          {!isEmpty(message)
            ? message
            : "Are you sure you want to delete this?"}
        </p>
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button className="remove-btn w-100" onClick={handleDelete}>
            {deleteBtnTxt}
          </button>
          <button className="c-b-btn w-100" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
